import React, { createContext, useCallback, useContext } from 'react';
import { axiosTimeout } from '../helpers/axiosTimeout';
import api from '../services/api';

const WorkflowContext = createContext();

const WorkflowProvider = ({ children }) => {
  const getWorkflowManagerParameterization = useCallback(
    async ({ branchId, transportTypeId, pickupTypeId, inputTypeId }) => {
      const token = localStorage.getItem('@Braspress:token');

      const response = await api.get(
        `${process.env.REACT_APP_URL_MS_WORKFLOW}/workflow/parameterization-exist`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            branchId,
            transportTypeId,
            pickupTypeId,
            inputTypeId
          },
          timeout: axiosTimeout
        }
      );

      const { data } = response.data;

      return data;
    },
    []
  );

  const getWorkflowManagerGeneralWorkflowTypes = useCallback(
    async ({ branchWorkflowParameterizationId }) => {
      const token = localStorage.getItem('@Braspress:token');

      const response = await api.get(
        `${process.env.REACT_APP_URL_MS_WORKFLOW}/branch/workflow/general/workflow-type`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: { branchWorkflowParameterizationId },
          timeout: axiosTimeout
        }
      );

      return response;
    },
    []
  );

  const getWorkflowManagerPreCollection = useCallback(
    async ({ branchWorkflowParameterizationId }) => {
      const token = localStorage.getItem('@Braspress:token');

      const response = await api.get(
        `${process.env.REACT_APP_URL_MS_WORKFLOW}/branch/workflow/collection`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: { branchWorkflowParameterizationId },
          timeout: axiosTimeout
        }
      );

      return response;
    },
    []
  );

  const contextValues = {
    getWorkflowManagerParameterization,
    getWorkflowManagerGeneralWorkflowTypes,
    getWorkflowManagerPreCollection
  };

  return (
    <WorkflowContext.Provider value={contextValues}>
      {children}
    </WorkflowContext.Provider>
  );
};

function useWorkflow() {
  const context = useContext(WorkflowContext);

  if (!context) {
    throw new Error('useWorkflow must be used within an WorkflowProvider');
  }

  return context;
}

export { WorkflowProvider, useWorkflow };
